import styled, { CSSObject } from 'styled-components';

interface BottomNavStyledProps {
  sx?: CSSObject;
}

const BottomNavStyled = styled.div<BottomNavStyledProps>(({ theme, sx }) => {
  return {
    height: 44,
    display: 'flex',
    boxSizing: 'border-box',
    background: theme.color.wfWhite,
    ...sx,
  };
});

export { BottomNavStyled };
